export * from '../src/components/wui-loading-thumbnail/index.js';
//# sourceMappingURL=wui-loading-thumbnail.js.map